import { SingleResponse } from "@/src/core/response"
import { sendRequest } from "@/src/core/http-client"
import Category from "@/src/interfaces/catalog/category";
import Merchant from "@/src/interfaces/merchant/merchant";

export class CategoryService {
    static async getAll(param: Category.SearchParams, appAccessToken?: string, tag?: string, merchant?: Merchant.ResponseSummary): Promise<SingleResponse<Category.Response>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/categories/${param.merchantId}`;

        const params = new URLSearchParams();

        if (param.onlyActive) params.append('OnlyActive', `${param.onlyActive}`)
        if (param.page) params.append('Page', `${param.page}`)
        if (param.pageSize) params.append('PageSize', `${param.pageSize}`)
        if (param.paged) params.append('Paged', `${param.paged}`)
        if (param.sortingColumn) params.append('SortingColumn', param.sortingColumn)
        if (param.sortingDirection) params.append('SortingDirection', param.sortingDirection)

        params.append('SellOnline', `${param.sellOnline}`)

        const finalUrl = `${baseUrl}?${params.toString()}`

        const response = await sendRequest<Category.Response>(
            appAccessToken,
            finalUrl,
            'GET',
            undefined,
            undefined,
            {
                cache: undefined,
                next: {
                    revalidate: 86400, // 24 horas.
                }
            }
        )

        if (response.model) {
            if (merchant?.categoriesSortType === 'Alphabetical')
                response.model.items = response.model.items.sort((a, b) => a.name.localeCompare(b.name))
            else
                response.model.items = response.model.items.sort((a, b) => a.sortIndex - b.sortIndex)
        }

        return response
    }

    static async getById(param: Category.CategorySearchParams, appAccessToken?: string): Promise<SingleResponse<Category.Category>> {
        const baseUrl = `${process.env.NEXT_PUBLIC_CATALOG_URL}/categories/${param.merchantId}/${param.id}`;

        const params = new URLSearchParams();

        if (param.onlyActive) params.append('OnlyActive', `${param.onlyActive}`)
        if (param.page) params.append('Page', `${param.page}`)
        if (param.pageSize) params.append('PageSize', `${param.pageSize}`)
        if (param.paged) params.append('Paged', `${param.paged}`)
        if (param.sortingColumn) params.append('SortingColumn', param.sortingColumn)
        if (param.sortingDirection) params.append('SortingDirection', param.sortingDirection)

        const finalUrl = `${baseUrl}?${params.toString()}`

        return sendRequest<Category.Category>(appAccessToken, finalUrl, 'GET')
    }
}